<template>

	<Toast />

	<SubmitConfirmDialog v-model:visible="showConfirmDialog" :vendor-name="vendorName" :company-name="companyName"
		:email="selectedEmail?.email" :loading="submitting" @confirm="executeSubmit" />

	<div class="grid">

		<div class="col-12">

			<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />

		</div>


		<div v-if="!isVendorSnapTaken" class="col-12 mb-4">

			<div class="content-wrapper">

				<div class="content-header">Vendor Email Setting</div>

				<div class="content-body">

					<div class="col-12 p-fluid">

						<div class="grid formgrid" style="margin: 1em 0 0 0">

							<div class="col-12 mb-5 lg:col-6">

								<span class="p-float-label">

									<InputText v-model="vendorName" class="w-full" style="color: #000" disabled />

									<label>Vendor Name</label>

								</span>

							</div>



							<!-- <div class="col-12 mb-5 lg:col-6">

								<span class="p-float-label">

									<InputText v-model="companyName" class="w-full" style="color: #000" disabled />

									<label>Company</label>

								</span>

							</div> -->



							<div class="col-12 mb-5 lg:col-6">

								<span class="p-float-label">

									<template v-if="isSnapRegistered">

										<InputText :modelValue="snapAccess?.email || ''" class="w-full"
											style="color: #000" disabled />

									</template>

									<EmailLovDropdown v-else-if="!isVendorSnapTaken && userId && companyName"
										:key="`${userId}-${companyName}`" v-model="selectedEmail" :user-id="userId"
										:company-name="companyName" :disabled="loading || isSubmitted"
										@loaded="onSettingLoaded" />

									<label>Email</label>

								</span>

								<small v-if="emailError" class="p-error">{{ emailError }}</small>

							</div>

						</div>

					</div>

				</div>

			</div>

		</div>



		<div v-if="checkingSnapStatus" class="col-12 mb-4">
			<TermsSectionSkeleton />
		</div>

		<div v-else-if="isVendorSnapTaken" class="col-12 mb-4">
			<SnapVendorTakenAlert :username="registeredByUsername" />
		</div>

		<div v-else-if="isSnapRegistered" class="col-12 mb-4">
			<SnapAccessCardSkeleton v-if="enteringSnap" />
			<SnapAccessCard v-else :email="snapAccess?.email" :registered-at="snapAccess?.creation_date"
				@enter-snap="handleEnterSnap" />
		</div>

		<template v-else>

			<div class="col-12 mb-4">

				<div class="content-wrapper">

					<div class="content-header">Terms and Conditions</div>

					<div class="content-body">

						<div class="terms-box">

							<p>

								Dengan menyetujui pemilihan email ini, user di Snap akan

								menggunakan email yang dipilih oleh user untuk keperluan

								notifikasi dan komunikasi terkait transaksi di sistem Snap.

							</p>

							<p>

								Pastikan email yang dipilih aktif dan dapat menerima notifikasi

								dari sistem. Perubahan email setelah submit akan memengaruhi

								seluruh user Snap yang terkait dengan vendor ini.

							</p>

						</div>



						<div class="flex align-items-center mt-4">

							<Checkbox v-model="termsAccepted" :binary="true" inputId="termsAccepted"
								:disabled="isSubmitted" />

							<label for="termsAccepted" class="ml-2 terms-label">

								Saya setuju dengan Terms and Conditions di atas

							</label>

						</div>

						<small v-if="termsError" class="p-error">{{ termsError }}</small>

					</div>

				</div>

			</div>



			<div class="col-12 mb-4">

				<div class="card">

					<div class="flex justify-content-end gap-4">

						<Button label="Submit" icon="pi pi-check" class="p-button-primary uppercase"
							@click="handleSubmit" :disabled="loading || isSubmitted" :loading="submitting" />

					</div>

				</div>

			</div>

		</template>

	</div>

</template>



<script setup>

import { onMounted, ref } from 'vue';

import { useToast } from 'primevue/usetoast';

import SimpleCrypto from 'simple-crypto-js';

import AuthService from '@/service/AuthService';

import LovService from '@/service/LovService';

import PoFulfillment from '@/service/PoFulfillment';

import VendorListService from '@/service/VendorListService';

import EmailLovDropdown from './components/EmailLovDropdown.vue';

import SubmitConfirmDialog from './components/SubmitConfirmDialog.vue';

import SnapAccessCard from './components/SnapAccessCard.vue';
import SnapAccessCardSkeleton from './components/SnapAccessCardSkeleton.vue';
import TermsSectionSkeleton from './components/TermsSectionSkeleton.vue';
import SnapVendorTakenAlert from './components/SnapVendorTakenAlert.vue';



const toast = useToast();



const breadcrumbHome = { icon: 'pi pi-home', to: '/dashboard' };

const breadcrumbItems = [

	{ label: 'Vendor List', to: '/mgm/setting/vendorlist' },

];



const loading = ref(true);
const checkingSnapStatus = ref(true);

const submitting = ref(false);
const enteringSnap = ref(false);
const isSubmitted = ref(false);

const isSnapRegistered = ref(false);
const isVendorSnapTaken = ref(false);
const registeredByUsername = ref('');

const showConfirmDialog = ref(false);



const userId = ref(null);

const usermappingId = ref(null);

const vendorId = ref(null);

const dbInstance = ref(null);

const vendorName = ref('');

const companyName = ref('');



const selectedEmail = ref(null);

const snapAccess = ref(null);

const snapPortalUrl = ref('http://192.168.74.212:30701');
const snapPortalCallbackUrl = ref('http://192.168.74.212:30699/auth/portal/callback');

const termsAccepted = ref(false);

const emailError = ref('');

const termsError = ref('');



const userCompany = () => {

	const secretKey = 'some-unique-key';

	const simpleCrypto = new SimpleCrypto(secretKey);

	return simpleCrypto.decrypt(sessionStorage.getItem('dropdownCompany'));

};



const applySnapStatus = (data) => {
	if (!data) return;

	isSnapRegistered.value = !!data.snap_registered;
	isVendorSnapTaken.value = !!data.snap_vendor_taken;
	registeredByUsername.value = data.registered_by_username || '';
	snapAccess.value = data.snap_access || null;

	if (data.snap_portal_url) {
		snapPortalUrl.value = data.snap_portal_url;
	}

	if (data.snap_portal_callback_url) {
		snapPortalCallbackUrl.value = data.snap_portal_callback_url;
	}

	if (data.snap_registered && data.snap_access?.email) {
		selectedEmail.value = {
			email: data.snap_access.email,
			label: data.snap_access.email,
		};
	}
};

const redirectToSnapPortal = (accessToken, callbackUrl) => {
	const url =
		callbackUrl ||
		(accessToken
			? `${snapPortalCallbackUrl.value}?token=${encodeURIComponent(accessToken)}`
			: null);

	if (url) {
		window.location.href = url;
	}
};

const handleEnterSnap = async () => {
	if (!userId.value || !vendorId.value) return;

	enteringSnap.value = true;
	try {
		const result = await VendorListService.enterSnap({
			user_id: userId.value,
			vendor_id: vendorId.value,
		});

		if (result.status !== 200) {
			throw new Error(result.data?.data || 'Gagal masuk ke Snap portal');
		}

		const { accessToken, snap_portal_callback_url } = result.data.data;

		if (!accessToken) {
			throw new Error('Token Snap tidak ditemukan');
		}

		redirectToSnapPortal(accessToken, snap_portal_callback_url);
	} catch (e) {
		toast.add({
			severity: 'error',
			summary: 'Gagal',
			detail: e?.response?.data?.data || e?.message || 'Gagal masuk ke Snap',
			life: 3000,
		});
	} finally {
		enteringSnap.value = false;
	}
};



const validateEmail = () => {

	emailError.value = '';

	if (!selectedEmail.value) {

		emailError.value = 'Email wajib dipilih';

		return false;

	}

	if (!selectedEmail.value.username || !selectedEmail.value.password) {

		emailError.value = 'Data username atau password tidak tersedia';

		return false;

	}

	return true;

};



const validateTerms = () => {

	termsError.value = '';

	if (!termsAccepted.value) {

		termsError.value = 'Anda harus menyetujui Terms and Conditions';

		return false;

	}

	return true;

};



const onSettingLoaded = (data) => {

	if (data?.selected_email && !selectedEmail.value) {

		const emailValue = data.selected_email;

		const matched = data.email_lov?.find((item) => item.email === emailValue);

		selectedEmail.value = matched || {

			email: emailValue,

			label: emailValue,

		};

	}

	if (data?.id) usermappingId.value = data.id;

	if (data?.vendorid) vendorId.value = data.vendorid;

	if (data?.vendorname) vendorName.value = data.vendorname;
};



const loadSnapStatus = async () => {
	if (!userId.value || !vendorId.value) {
		checkingSnapStatus.value = false;
		return;
	}

	try {
		const result = await VendorListService.checkSnapAccess(
			userId.value,
			vendorId.value
		);

		if (result.status === 200) {
			applySnapStatus(result.data.data);
		}
	} catch (e) {
		console.error('Failed to check snap access:', e);
	} finally {
		checkingSnapStatus.value = false;
	}
};



const handleSubmit = () => {

	if (!validateEmail() || !validateTerms()) return;

	showConfirmDialog.value = true;

};



const executeSubmit = async () => {

	submitting.value = true;

	try {

		const portalPayload = {

			portalUsername: selectedEmail.value.username,

			password: selectedEmail.value.password,

			email: selectedEmail.value.email,

			user_id: userId.value,

			vendor_id: vendorId.value,

		};



		const portalResult = await VendorListService.submitPortal(portalPayload);

		if (portalResult.status !== 200) {
			throw new Error(
				portalResult.data?.data || 'Gagal submit ke Snap portal'
			);
		}

		const portalData = portalResult.data?.data;
		const accessToken = portalData?.accessToken || portalData?.portal?.accessToken;
		const callbackUrl = portalData?.snap_portal_callback_url;

		if (!accessToken) {
			throw new Error('Token Snap tidak ditemukan pada response portal');
		}



		const savePayload = {

			id: usermappingId.value,

			email: selectedEmail.value.email,

			user_id: userId.value,

			terms_accepted: termsAccepted.value,

		};



		const result = await VendorListService.submit(savePayload);

		if (result.status === 200) {

			isSubmitted.value = true;

			isSnapRegistered.value = true;

			snapAccess.value = {

				email: selectedEmail.value.email,

				username: selectedEmail.value.username,

				vendor_id: vendorId.value,

				creation_date: new Date().toISOString(),

			};

			showConfirmDialog.value = false;

			toast.add({
				severity: 'success',
				summary: 'Berhasil',
				detail: 'Email berhasil disubmit ke Snap. Mengalihkan ke Snap Portal...',
				life: 2000,
			});

			setTimeout(() => {
				redirectToSnapPortal(accessToken, callbackUrl);
			}, 2000);
		}

	} catch (e) {
		if (e?.response?.status === 409) {
			isVendorSnapTaken.value = true;
			registeredByUsername.value = e.response.data?.registered_by_username || '';
			showConfirmDialog.value = false;
			return;
		}

		toast.add({

			severity: 'error',

			summary: 'Gagal',

			detail: e?.response?.data?.data || e?.message || 'Gagal submit email',

			life: 3000,

		});

	} finally {

		submitting.value = false;

	}

};



onMounted(async () => {

	try {

		const authRes = await AuthService.whoAmi();

		if (authRes.status !== 200) return;



		const user = authRes.data.data;

		userId.value = user.id;



		const companyRes = await LovService.getCompanyByName(userCompany());

		if (companyRes.status === 200 && companyRes.data.data?.length) {

			const company = companyRes.data.data[0];

			companyName.value = company.name;

			dbInstance.value = company.db_instance;

		}



		const mappingRes = await PoFulfillment.getCompanySupp(user.id);

		if (mappingRes.status === 200 && mappingRes.data.data?.length) {

			const mapping = mappingRes.data.data.find(

				(item) => item.company === companyName.value

			) || mappingRes.data.data[0];

			usermappingId.value = mapping.id;

			vendorId.value = mapping.vendorid;

			vendorName.value = mapping.fullname || mapping.vendorname || '';

		}



		await loadSnapStatus();

	} catch (e) {

		console.error('Failed to initialize vendor list page:', e);

		toast.add({

			severity: 'error',

			summary: 'Error',

			detail: 'Gagal memuat data vendor',

			life: 3000,

		});

	} finally {

		loading.value = false;

	}

});

</script>



<style scoped>
.terms-box {

	background: #f8f9fb;

	border: 1px solid #e0e4ea;

	border-radius: 6px;

	padding: 16px 20px;

	color: #444;

	line-height: 1.6;

}



.terms-box p {

	margin: 0 0 12px;

}



.terms-box p:last-child {

	margin-bottom: 0;

}



.terms-label {

	cursor: pointer;

	color: #333;

}
</style>
